import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { ContentSidebar } from "@/components/marketing/ContentSidebar";

export const Route = createFileRoute('/concepts')({
  component: ConceptsLayout,
});

const conceptsSidebar = {
  title: "Concepts",
  sections: [
    {
      items: [
        { label: "Overview", href: "/concepts" },
      ]
    },
    {
      title: "API & Integration",
      items: [
        { label: "API Gateway", href: "/concepts/api-gateway", iconName: "Router" },
        { label: "API Management", href: "/concepts/api-management", iconName: "Globe" },
        { label: "Data Integration", href: "/concepts/data-integration", iconName: "Database" },
        { label: "Webhooks", href: "/concepts/webhooks", iconName: "Webhook" },
      ]
    },
    {
      title: "AI & Automation",
      items: [
        { label: "AI Agents", href: "/concepts/ai-agents", iconName: "Bot" },
        { label: "Workflow Automation", href: "/concepts/workflow-automation", iconName: "Workflow" },
      ]
    },
    {
      title: "Security",
      items: [
        { label: "Zero-Trust Security", href: "/concepts/zero-trust-security", iconName: "Shield" },
        { label: "RBAC vs ABAC", href: "/concepts/rbac-abac", iconName: "Lock" },
      ]
    }
  ]
};

function ConceptsLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container px-6 py-12">
        <div className="flex gap-12">
          <ContentSidebar
            title={conceptsSidebar.title}
            sections={conceptsSidebar.sections}
          />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
